<template>
  <div>
    <b-row>
      <b-col>
        <p v-if="this.skin.oosztaan">
          Om u in te schrijven bij Wonen Bij WOV moet u een uitreksel van het BRP uploaden. Een uitreksel van het BRP kunt u bij uw eigen gemeente of via MijnOverheid.nl opvragen. Na het uploaden van uw BRP beoordeeld de WOV uw aanvraag, waarna u via de mail een betalingsuitnodiging krijgt.
        </p>
        <p>
          Als u in aanmerking komt voor een woning, dan vraagt de woningcorporatie u om documenten aan te leveren. Deze documenten gaan onder andere over uw inkomen en woonsituatie.
        </p>
        <p>
          Als u een voorlopige aanbieding voor een woning krijgt, dan heeft u slechts korte tijd om deze documenten aan te leveren. Als u hoog op de lijst komt en dus een kansrijke kandidaat bent, is het verstandig om de documenten alvast te verzamelen en hier te uploaden. U bent dit niet verplicht. Maar als u te laat bent met het aanleveren en uploaden van de documenten, dan wordt de volgende kandidaat benaderd.
        </p>
        <h2>Let op: documenten uploaden vóór reageren</h2>
        <p>
          Voordat u kunt reageren op een woning van De Woonschakel of het Gemeentelijk Bedrijf Opmeer, moeten alle benodigde documenten vooraf geüpload zijn.
        </p>
        <p>
          Belangrijk: sommige documenten zijn maar een beperkte tijd geldig. Zorg er dus voor dat uw geüploade documenten nog geldig zijn op het moment van reageren.
        </p>
      </b-col>
    </b-row>
    <br>
    <form-loader v-if="loading"/>
    <template v-if="!loading">
      <template v-for="(group, index) in documents.groups">
        <document-group
                v-if="group.description.indexOf('Spoedzoeker') === -1"
                :summary="summary"
                :key="group.id"
                :group="group"
                :index="index"
                @file-upload="handleFileUpload"
                @file-removed="handleFileRemoved"
        />
      </template>
      <br>
      <FormButtons @next="next" @previous="$emit('previous')"/>
    </template>
  </div>
</template>
<script>
import { documentService } from '@/_services/document.service'
import FormButtons from '@/components/_registration/FormButtons'
import DocumentGroup from '@/components/_registration/DocumentGroup'
import { registrationService } from '@/_services/registration.service'
import FormLoader from '@/components/_registration/FormLoader'

export default {
  data: () => {
    return {
      loadingDocuments: false,
      loadingSummary: false,
      documents: {
        groups: []
      },
      summary: {},
      skin: {
        oosztaan: process.env.VUE_APP_OOSTZAAN,
      }
    }
  },
  components: { FormButtons, DocumentGroup, FormLoader },
  computed: {
    loading: function () {
      return (this.loadingDocuments || this.loadingSummary)
    },
  },
  methods: {
    fetchDocumentsData () {
      this.loadingDocuments = true
      documentService.getDocuments().then(result => {
        this.documents = result
      }).finally(() => {
        this.loadingDocuments = false
      })
    },

    fetchSummaryData () {
      this.loadingSummary = true
      registrationService.getSummary().then(result => {
        this.summary = result
      }).finally(() => {
        this.loadingSummary = false
      })
    },

    fetchData () {
      this.fetchDocumentsData()
      this.fetchSummaryData()
    },
    next () {
      this.$emit('validated', true)
      this.$emit('next')
    },

    handleFileUpload (file, typeIndex, groupIndex) {

      this.documents.groups[groupIndex].types[typeIndex].currentDocuments.push(file)
      this.recountDocuments(groupIndex)
    },

    handleFileRemoved (groupIndex, typeIndex, fileIndex) {
      this.documents.groups[groupIndex].types[typeIndex].currentDocuments.splice(fileIndex, 1)
      this.recountDocuments(groupIndex)
    },
    recountDocuments (groupIndex) {
      let partnerCount = 0
      let personCount = 0
      this.documents.groups[groupIndex].types.forEach(type => {
        type.currentDocuments.forEach(doc => {
          if (doc.partner) {
            partnerCount++
          } else {
            personCount++
          }
        })
      })

      this.documents.groups[groupIndex].currentDocumentCount = personCount
      this.documents.groups[groupIndex].currentPartnerDocumentCount = partnerCount

    },
  },
  mounted () {
    this.fetchData()
  },
  activated () {
    this.fetchData()
  },
}
</script>